import { Link } from "react-router-dom";
const AgentTabs = (props) => {
  return (
    <ul
      className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3"
      role="tablist"
    >
      <li className="nav-item">
        <Link
          to={"/agents"}
          className={
            props.pageName === "AGENT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          AGENTS
        </Link>
      </li>

      {/* <li className="nav-item" role="presentation">
                    <Link to={"/agent/payments"} className={props.pageName === "PAYMENTS" ? "nav-link active bg-primary text-white" : "nav-link"}>PAYMENTS</Link>
                </li>
                 <li className="nav-item" role="presentation">
                    <Link to={"/agent/credits"} className={props.pageName === "CREDIT" ? "nav-link active bg-primary text-white" : "nav-link"}>CREDIT HISTORY</Link>
                </li>
                <li className="nav-item" role="presentation">
                    <Link to={"/agent/invoices"} className={props.pageName === "INVOICE" ? "nav-link active bg-primary text-white" : "nav-link"}>INVOICES</Link>
                </li> */}
    </ul>
  );
};

export default AgentTabs;
